import React from "react";
import Modal from "react-bootstrap/Modal";
import { BsCheckCircleFill } from "react-icons/bs";
import SubmitTimesheet from "../components/SubmitTimesheet";

const ApproveTimesheetModal = ({
  visible,
  close,
  shift,
  updateShift,
  cancelAction,
}) => {
  return (
    <Modal
      show={visible}
      onHide={close}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          <h1 className={"text-axis-offblack icon-text-wrapper"}>
            <BsCheckCircleFill className={"icon-right-spacing"} />
            Submit Timesheet
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SubmitTimesheet
          shift={shift}
          onComplete={(s) => {
            updateShift(s);
            close();
          }}
          close={close}
        />
      </Modal.Body>
    </Modal>
  );
};

export default ApproveTimesheetModal;
